import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Paths } from '../../../enums';
import { ReverseAuthGuard } from '../../../guard';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [ReverseAuthGuard],
    component: LoginComponent
  },
  {
    path: Paths.adminLogin,
    canActivate: [ReverseAuthGuard],
    component: LoginComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
